import ParentScrollView from "components/ParentScrollView";
import VText from "components/VText";
import Heading from "components/Heading";
import Paragraph from "components/Pharagraph";
import { View, Image, Linking } from "react-native";
import { fp, spH, spV, wp, hp } from "utils/normalizeV2";
import Buttons from "components/Buttons";
import { Svg } from "assets/svg";
import { useState } from "react";
import { StyleSheet } from "react-native";
import Carousel from "react-native-reanimated-carousel";
import { Images } from "assets";
import { useRef } from "react";
import Pagination from "components/Pagination";
import { useLocalSearchParams, useRouter } from "expo-router";

export default function ConciergeServices() {
  const router = useRouter();
  const local = useLocalSearchParams();
  const gender = local?.gender ?? "female";
  const [selectedService, setSelectedService] = useState([
    {
      title: "Chat with Stylist",
      image: Svg.chatIcon,
    },
    {
      title: "Send Recommendations",
      image: Svg.recomadIcon,
    },
    {
      title: "Personalized Suggestions",
      image: Svg.stylingIcon,
    },
    {
      title: "Organize Closet",
      image: Svg.closetIcon,
    },
    {
      title: "Calendar Sync",
      image: Svg.calanderIcon,
    },
  ]);

  const [activeIndex, setActiveIndex] = useState(0);
  const _slider1Ref = useRef(null);

  const carouselData = [
    { image: Images.gloveDigitilImage1 },
    { image: Images.gloveDigitilImage2 },
    { image: Images.gloveDigitilImage3 },
  ];

  const _renderItem = ({ item, index }) => {
    const isActive = activeIndex === index;
    return (
      <Image
        accessibilityLabel={`White Glove Digitization Image ${index + 1}`}
        source={item.image}
        style={{ width: "400", height: "100%", opacity: isActive ? 1 : 0.5 }}
        resizeMode="contain"
      ></Image>

      // </View>
    );
  };

  return (
    <ParentScrollView>
      <View style={styles.container}>
        <Heading type="h1" style={styles.heading}>
          White Glove Digitization
        </Heading>
        <View style={styles.contentContainer}>
          <View style={styles.carouselView}>
            <Carousel
              loop
              width={320}
              height={500} // added 32 + extra for dynamic image height
              ref={_slider1Ref}
              autoPlay={true}
              autoPlayInterval={2000}
              data={carouselData}
              onConfigurePanGesture={(PanGesture) => {}}
              style={{ overflow: "visible" }}
              mode="parallax"
              modeConfig={{
                parallaxScrollingScale: 1,
                parallaxScrollingOffset: 100,
                parallaxAdjacentItemScale: 0.75,
              }}
              scrollAnimationDuration={1000}
              renderItem={_renderItem}
              onSnapToItem={(index) => setActiveIndex(index)}
              numberOfVisibleItems={3}
            />
            <Pagination
              style={{
                marginTop: spV(50),
              }}
              thickness={8}
              backgroundColor="black"
              data={Array.isArray(carouselData) ? carouselData : []}
              selectedIndex={activeIndex}
              containerStyle={{
                width: "100px",
                paddingVertical: 14,
                alignItems: "center",
                justifyContent: "center",
                // backgroundColor:"red"
              }}
            />
          </View>
          <View style={styles.contentText}>
            <Heading type="h5" style={styles.contentHeading}>
              WHITE GLOVE IN-HOME DIGITAL CLOSETIZATION
            </Heading>
            <VText style={styles.contentSubHeading}>
              <Paragraph>
                Step into the future of wardrobe management with our White Glove
                Digital Closet Service. By appointment, our expert team will
                seamlessly transform your at-home closet into a smart, digital
                haven so your full wardrobe is always in the palm of your hand.
                To learn more, email us{" "}
                <VText
                  text="Concierge@vetirapp.com"
                  style={styles.link}
                  onPress={() =>
                    Linking.openURL("mailto:Concierge@vetirapp.com")
                  }
                ></VText>
                .
              </Paragraph>
            </VText>
            <Heading type="h5" style={styles.contentHeading}>
              VIRTUAL DIGITAL CLOSETIZATION
            </Heading>
            <VText style={styles.contentSubHeading}>
              <Paragraph>
                Let us digitize your closet remotely. Our team will upload and
                organize your closet into the app so you have easy access to
                everything in your wardrobe. To learn more, email us at{" "}
                <VText
                  style={styles.link}
                  onPress={() =>
                    Linking.openURL("mailto:Concierge@vetirapp.com")
                  }
                >
                  Concierge@vetirapp.com
                </VText>
                .{" "}
              </Paragraph>
            </VText>

            <Heading type="h5" style={styles.contentHeading}>
              STYLING
            </Heading>
            <VText style={styles.contentSubHeading}>
              <Paragraph>
                Whether you need a seasonal wardrobe refresh or something to
                wear for a special event, our team of stylists are here to help.
                Simply let us know what you’re looking for and we will curate
                designer outfits specifically for you and your taste.{" "}
              </Paragraph>
            </VText>

            <Heading type="h5" style={styles.contentHeading}>
              SOURCING & GIFTING
            </Heading>
            <VText style={styles.contentSubHeading}>
              <Paragraph>
                Looking for the most coveted designer pieces? Let us do the
                searching for you. With our extensive network, we are able to
                source all the hard-to-find pieces and special gifts.  To learn
                more about any of the above services, please contact us at{" "}
                <VText
                  style={styles.link}
                  onPress={() =>
                    Linking.openURL("mailto:Concierge@vetirapp.com")
                  }
                >
                  Concierge@vetirapp.com
                </VText>
                .{" "}
              </Paragraph>
            </VText>

            <Buttons
              style={styles.button}
              containerStyle={styles.buttonContainer}
              text="View Closet Options"
              onPress={() => {
                router.push(
                  `${
                    gender == "men" ? "/men" : ""
                  }/white-glove-digitization-details`
                );
              }}
            />
          </View>
        </View>

        <View style={styles.StylingServicesContainer}>
          <Heading type="h1" style={styles.heading}>
            Personal Styling Services
          </Heading>
          <View style={styles.StylingServices}>
            {selectedService.map((item, index) => (
              <View style={styles.StylingServicesItem}>
                <Image
                  accessibilityLabel={item.title}
                  source={item.image}
                  style={styles.StylingServicesImage}
                  resizeMode="contain"
                />
                <Heading type="h5" style={styles.StylingServicesText}>
                  {item.title}
                </Heading>
              </View>
            ))}
          </View>
        </View>
      </View>
    </ParentScrollView>
  );
}

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: spH(40),
    paddingVertical: spV(30),
    alignItems: "center",
  },
  heading: {
    fontSize: fp(32),
    fontFamily: "LibreBodoni",
    fontWeight: "350",
    color: "#212427",
  },
  carouselView: {
    width: wp(600),
    alignItems: "center",
    // overflow: "hidden",
    marginRight: spH(60),
  },

  contentContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    paddingVertical: spV(40),
    borderBottomWidth: 1,
    borderColor: "#21242729",
  },

  contentHeading: {
    fontSize: fp(15),
    fontWeight: "600",
  },
  contentSubHeading: {
    fontSize: fp(16),
    fontWeight: "350",
    paddingVertical: spV(15),
  },
  contentText: {
    paddingVertical: spV(20),
    width: wp(550),
    // paddingLeft: spH(0),
    backgroundColor: "white",
  },

  button: {
    marginTop: spV(20),
  },
  buttonContainer: {
    marginTop: spV(20),
    width: wp(320),
    height: hp(36),
  },
  StylingServicesContainer: {
    paddingTop: spV(40),
    alignItems: "center",
  },

  StylingServices: {
    flexDirection: "row",
    justifyContent: "space-between",
    // paddingHorizontal: spH(40),
    paddingTop: spV(40),
    gap: wp(50),
  },
  StylingServicesHeading: {
    fontSize: fp(15),
    fontWeight: "600",
  },
  StylingServicesItem: {
    alignItems: "center",
  },
  StylingServicesImage: {
    width: fp(40),
    height: fp(40),
    marginBottom: spV(10),
  },
  StylingServicesText: {
    fontSize: fp(16),

    fontWeight: "450",
  },
  link: {
    fontWeight: "400",
    // cursor: "pointer",
  },
});
